import * as React from "react"
import { List } from "immutable"
import { Link } from "./library/link"
import { QuickLinks, QuickLink } from "./quick_links";
import { slugify } from "../../custom_utils/helpers";
import { pushBuildingBlockAction } from "./datalayer";

export type CollectionBlockProps = {
  title: string
  introduction: string
  displayQuickLinks: boolean
  collectionGroups: List<CollectionGroup>
}

export type CollectionGroup = {
  slug: string
  title: string
  collectionItems: List<CollectionGroupItem>
}

export type CollectionGroupItem = {
  title: string
  subtitle: string
  text: string
  link: string
  icon: CollectionGroupItemIcon | "none"
}
export type CollectionGroupItemIcon =
  | "newspaper"
  | "finance-daily"
  | "newspaper-history"
  | "extract"
  | "extract-jr"
  | "extract-history"
  | "learn"
  | "pass"
  | "van-dale"
  | "film"
  | "music"
  | "consumentenbond"
  | "book-jr"
  | "winkler-prins"
  | "winkler-prins-jr"
  | "research"
  | "video"

export type CollectionGroupItemIconList = List<CollectionGroupItemIcon>

export const collectionGroupItemIconList: CollectionGroupItemIconList = List<CollectionGroupItemIcon>([
  "newspaper",
  "finance-daily",
  "newspaper-history",
  "extract",
  "extract-jr",
  "extract-history",
  "learn",
  "pass",
  "van-dale",
  "film",
  "music",
  "consumentenbond",
  "book-jr",
  "winkler-prins",
  "winkler-prins-jr",
  "research",
  "video",
])

export class CollectionBlock extends React.Component<CollectionBlockProps, {}> {
  componentDidMount() {
    setTimeout(() => this.scrollToGroupByCurrentHash(), 500)
    window.addEventListener("hashchange", () => this.scrollToGroupByCurrentHash())
  }

  scrollToGroupByCurrentHash() {
    this.scrollToGroup(window.location.hash.substr(1))
  }

  scrollToGroup(slug: string) {
    const element = document.querySelector(`[data-anchor="${slug}"]`)
    if (!element) return
    element.scrollIntoView({ behavior: "smooth" })
  }

  render() {
    const {title, introduction, displayQuickLinks, collectionGroups} = this.props

    return (
      <section className="block block--knowledge-bank">
        {(title || introduction) &&
          <header className="block__header">
            {title && <h2 className="block__title title--l">{title}</h2> }
            {introduction && <div className="block__intro" dangerouslySetInnerHTML={{ __html: introduction }} /> }
          </header>
        }

        {displayQuickLinks &&
          <QuickLinks
            title="Direct naar..."
            links={collectionGroups.map<QuickLink>((group) => ({ title: group.title, url: '#' + group.slug })).toList()}
            handleScroll={(slug: string) => this.scrollToGroup(slug)}
            pushAnalyticsEvent={(action: string) => pushBuildingBlockAction(action)}
          />
        }

        {collectionGroups.map(group => (
          <article key={`group-${group.slug}`} data-anchor={group.slug} className="block__content">
            <h3 className="block__subtitle title--m">{group.title}</h3>

            <ul className="cards">
              {group.collectionItems.map((item, itemKey) => (
                <li className="card" key={`group-${group.slug}-${itemKey}`}>
                  <Link url={item.link} className="card__link" aria-labelledby={`a11y-card-title-${slugify(item.title)}`}>
                    <div className="card__content">
                      <h4 className="card__title title--ms" id={`a11y-card-title-${slugify(item.title)}`}>{item.title}</h4>
                      <p className="card__subtitle">{item.subtitle}</p>
                      <p className="card__text">{item.text}</p>
                    </div>
                    <div className="card__visual" aria-hidden="true">
                      <svg className="card__icon">
                        <use xlinkHref={`#icon--${item.icon == "none" ? "book" : item.icon}`} />
                      </svg>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </section>
    )
  }
}
